export const pageTitle = (title) => {
  return (document.title = title + " - Tinqlab - Expert software and blockchain developers - Tinqlab.com");
}